module.exports = __webpack_public_path__ + "img/24.9b87b936.jpg";